import { render, staticRenderFns } from "./selectsharePop.vue?vue&type=template&id=f20fdef0&scoped=true&"
import script from "./selectsharePop.vue?vue&type=script&lang=js&"
export * from "./selectsharePop.vue?vue&type=script&lang=js&"
import style0 from "./selectsharePop.vue?vue&type=style&index=0&id=f20fdef0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20fdef0",
  null
  
)

export default component.exports